"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const epi_storybook_1 = require("@episource/epi-storybook");
const material_1 = require("@mui/material");
const InfoGridItem_1 = require("./InfoGridItem");
const InfoGrid = (props) => {
    const { items, secondaryPalette = false, itemClasses = {} } = props;
    const PrimaryPaletteGrid = (0, material_1.styled)(material_1.Grid)(({ theme }) => ({
        backgroundColor: epi_storybook_1.signetThemeTokens.solidBackground.generalDarker.value,
        borderLeft: `10px solid ${epi_storybook_1.signetThemeTokens.primary.dark.value}`,
    }));
    const SecondaryPaletteGrid = (0, material_1.styled)(material_1.Grid)(({ theme }) => ({
        backgroundColor: (0, material_1.alpha)(theme.palette.secondary.light, 0.25),
        borderLeft: `10px solid ${theme.palette.secondary.main}`,
    }));
    const infoGridArgs = {
        container: true,
        spacing: 0,
        alignItems: "stretch",
        "data-testid": "infogrid",
    };
    const infoGridItems = (react_1.default.createElement(react_1.default.Fragment, null, items.map((item, index) => (react_1.default.createElement(InfoGridItem_1.InfoGridItem, { key: index, width: item.width || 3, name: item.name, value: item.value, secondaryValue: item.secondaryValue, itemClasses: itemClasses })))));
    const InfoGridElement = secondaryPalette
        ? SecondaryPaletteGrid
        : PrimaryPaletteGrid;
    return (react_1.default.createElement(material_1.Paper, null,
        react_1.default.createElement(InfoGridElement, { ...infoGridArgs }, infoGridItems)));
};
exports.default = InfoGrid;
